import { BackStageTemplateService } from 'src/app/share/service/back-stage-template.service';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { GlobalComponentService } from '@techmore/global';
import { TemplateService } from '../../service/template.service';

@Component({
  selector: 'app-template-controller',
  templateUrl: './template-controller.component.html',
  styleUrls: ['./template-controller.component.scss']
})
export class TemplateControllerComponent {
  constructor(
    private templateService: TemplateService,
    private globalComponentService: GlobalComponentService,
  ) {}

  updateTemplate() {
    this.templateService.updateTemplate().subscribe(() => this.globalComponentService.openInfoAlert('更新成功'));
  }
}
